import React from "react";
import hero from "../../Assets/Images/hero.png";
import Button from "../Inputs/Button";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#FFF] flex-col sm:flex-row gap-6 flex-wrap pt-10 pb-14 px-4 sm:pl-[60px] sm:pr-8 flex ">
      <div className="flex-1  flex flex-col justify-center">
        <h3 className="font-[600] text-[40px] sm:text-[72px] text-[#000] leading-[48px] sm:leading-[74px] ">
          Welcome to Greengate Pharmaceuticals
        </h3>
        <h4 className="font-[400] text-[18px] sm:text-[22.2px] mt-4 sm:mt-4 mb-9 sm:mb-16 text-[#000] sm:leading-[29px] ">
          ⁠Innovating Health, Inspiring Care.
        </h4>
        <Button
          onClick={() => {
            navigate("/about-us");
          }}
          title={"About us"}
        />
      </div>
      <div className="flex-1 mt-6 sm:mt-auto items-center sm:items-end justify-center sm:justify-end flex">
        <img
          src={hero}
          alt=""
          className="max-h-[75vh] w-full h-[50vh] sm:min-w-[600px] sm:min-h-[75vh] object-cover"
        />
      </div>
    </div>
  );
};

export default Hero;
